import api from '../../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'
import {
    MARK_COMPANY_DELIVERY_AS_PAID,
    
    GET_COMPANY_DEALERS,

    GET_COMPANY_SHIPPINGS,
    GET_COMPANY_SHIPPING_RATES,

    CREATE_COMPANY_DEALER,
    UPDATE_COMPANY_DEALER,
    DELETE_COMPANY_DEALER,

    CREATE_COMPANY_SHIPPING_RATE,
    UPDATE_COMPANY_SHIPPING_RATE,
    DELETE_COMPANY_SHIPPING_RATE,

    CREATE_COMPANY_DELIVERY_RATE,

    UPDATE_DELIVERY_MODE,
    GET_DELIVERY_MODE,  
    GET_DELIVERY_MODE_RATES,

    CREATE_DELIVERY_MODE_RATE,
    
    GET_DELIVERY_COMPANY,
    UPDATE_DELIVERY_COMPANY,
    UPDATE_DELIVERY_COMPANY_BY_ID,
    GET_DELIVERY_COMPANIES,
    GET_LINKED_STORES,
    GET_COMPANY_DEALER_DELIVERIES,
    GET_COMPANY_SHIPPING_DETAILS,

} from './actions.type'
import { FETCH_START, FETCH_END, SET_COMPANY_DEALERS, SET_COMPANY_SHIPPINGS, SET_DELIVERY_COMPANY, SET_COMPANY_SHIPPING_RATES, SET_LINKED_STORES, SET_DELIVERY_COMPANIES, SET_DELIVERY_MODE_RATE } from './mutations.type';

const state = {
  companyDealers: [],
  companyShippings: [],
  companyShippingRates: [],
  deliveryCompany: null,
  deliveryCompanies: [],
  linkedStores: [],
  loading: false,
}

const getters = {
  companyDealers: state => state.companyDealers,
  companyShippings: state => state.companyShippings,
  companyShippingRates: state => state.companyShippingRates,
  deliveryCompany: state => state.deliveryCompany,
  deliveryCompanies: state => state.deliveryCompanies,
  linkedStores: state => state.linkedStores,
}

const mutations = {
  [SET_COMPANY_DEALERS](state, dealers) {
    state.companyDealers = dealers
  },
  [SET_COMPANY_SHIPPINGS](state, shippings) {
    state.companyShippings = shippings
  },
  [SET_COMPANY_SHIPPING_RATES] (state, shippingRates) {
    state.companyShippingRates = shippingRates
  },
  [SET_DELIVERY_COMPANY] (state, deliveryCompany) {
    state.deliveryCompany = deliveryCompany
  },
  [SET_DELIVERY_COMPANIES] (state, deliveryCompanies) {
    state.deliveryCompanies = deliveryCompanies
  },
  [SET_LINKED_STORES] (state, linkedStores) {
    state.linkedStores = linkedStores
  },
  [SET_DELIVERY_MODE_RATE] (state, deliveryModeRate) {
    state.deliveryModeRate = deliveryModeRate
  },
  [FETCH_START](state) {
    Nprogress.start()
    state.loading = true
  },
  [FETCH_END](state) {
    Nprogress.done()
    state.loading = false
  }
}

const actions = {
  async [GET_DELIVERY_COMPANY]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/deliver/mycompany`)
      commit(SET_DELIVERY_COMPANY, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_DELIVERY_COMPANIES]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/deliver`)
      commit(SET_DELIVERY_COMPANIES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [UPDATE_DELIVERY_COMPANY]({ commit, dispatch }, deliveryCompany) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`/deliver`, deliveryCompany)
      dispatch(GET_DELIVERY_COMPANY)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Información actualizada exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar la información'
      })
    }
  },
  async [UPDATE_DELIVERY_COMPANY_BY_ID]({ commit, dispatch }, deliveryCompany) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`/deliver/${deliveryCompany.id}`, deliveryCompany)
      dispatch(GET_DELIVERY_COMPANY)
      commit(FETCH_END)
    } catch (err) {
      commit(FETCH_END)
    }
  },
  async [GET_COMPANY_DEALER_DELIVERIES] ({ commit }, dealerId) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`deliver/dealer/${dealerId}`)
      commit(FETCH_END)
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_COMPANY_DEALERS] ({ commit }) {
    try {
      commit(FETCH_START)
      const { data } = await api.get(`/deliver/dealer`)
      commit(SET_COMPANY_DEALERS, data)
      commit(FETCH_END)
      return data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_COMPANY_SHIPPINGS]({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/deliver/delivery`)
      commit(SET_COMPANY_SHIPPINGS, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_COMPANY_SHIPPING_RATES] ({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get('/deliver/price')
      commit(SET_COMPANY_SHIPPING_RATES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [GET_LINKED_STORES] ({ commit }) {
    try {
      commit(FETCH_START)
      const res = await api.get('/deliver/stores')
      commit(SET_LINKED_STORES, res.data)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [MARK_COMPANY_DELIVERY_AS_PAID] ({commit, dispatch}, delivery){
  try {
    commit(FETCH_START)
    const res = await api.patch(`/delivery/pay/${delivery.bill_id}`)
    await dispatch(GET_COMPANY_SHIPPINGS)
    commit(FETCH_END)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: '✔️ Pago actualizado exitosamente'
    })
  } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido al marcar como pagado'
      })
    }
  },
  async [CREATE_COMPANY_DEALER]({ dispatch, commit }, dealer) {
    try {
      commit(FETCH_START)
      const res = await api.post(`deliver/dealer`, dealer)
      await dispatch(GET_COMPANY_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor creado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear el repartidor'
      })
    }
  },
  async [UPDATE_COMPANY_DEALER]({ dispatch, commit }, dealer) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`deliver/dealer/${dealer.id}`, dealer)
      await dispatch(GET_COMPANY_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor actualizado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar el repartidor'
      })
    }
  },
  async [DELETE_COMPANY_DEALER]({ dispatch, commit }, dealerId) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`deliver/dealer/${dealerId}`)
      await dispatch(GET_COMPANY_DEALERS)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Repartidor eliminado exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar el repartidor'
      })
    }
  },
  async [CREATE_COMPANY_DELIVERY_RATE] ({}, deliveryRate) {
    try {
      commit(FETCH_START)
      const res = await api.post(`rate-delivery-location/${deliveryRate.id}/create`, deliveryRate)
      await dispatch(GET_COMPANY_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta creada exitosamente'
      })
    } catch (error) {
      
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear la ruta'
      })
    }
  },
  async [CREATE_COMPANY_SHIPPING_RATE] ({dispatch, commit}, shippingRate) {
    try {
      commit(FETCH_START)
      const res = await api.post('deliver/price', shippingRate)
      await dispatch(GET_COMPANY_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta creada exitosamente'
      })
    } catch (error) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al crear la ruta'
      })
    }
  },
  async [UPDATE_COMPANY_SHIPPING_RATE]({ dispatch, commit }, shippingRate) {
    try {
      commit(FETCH_START)
      const res = await api.patch(`/deliver/price/${shippingRate.id}`, shippingRate)
      await dispatch(GET_COMPANY_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta actualizada exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar la ruta'
      })
    }
  },
  async [DELETE_COMPANY_SHIPPING_RATE]({ dispatch, commit }, shippingRateId) {
    try {
      commit(FETCH_START)
      const res = await api.delete(`/deliver/price/${shippingRateId}`)
      await dispatch(GET_COMPANY_SHIPPING_RATES)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Ruta eliminada exitosamente'
      })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al eliminar la ruta'
      })
    }
  },
  async [GET_COMPANY_SHIPPING_DETAILS] ({ commit }, shippingId) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/deliver/delivery/${shippingId}`)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
      })
    }
  },
  async [UPDATE_DELIVERY_MODE] ({ commit, rootGetters }, mode) {
    const text = mode ? '✔️ Cobro por geolocalización activado exitosamente':
                                     '✔️ Cobro por geolocalización desactivado exitosamente'
    try {
      commit(FETCH_START)      
      const id = rootGetters.deliveryCompany.id
      const deliveryMode = { id: id, mode: mode }
      
      const res = await api.patch(`/delivery/${id}/update-mode`, deliveryMode)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: text
      })
    } catch (err) {
      console.error(err)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al activar/desactivar el envío por geolocalización'
      })
    }
  },
  async [GET_DELIVERY_MODE_RATES] ({ commit, rootGetters}) {
    try {
      commit(FETCH_START)
      const res = await api.get(`/rate-delivery-location/get-all-rate-delivery-location`)
      commit(FETCH_END)
      return res.data
    } catch (err) {
      commit(FETCH_END)
    }
  },
  async [CREATE_DELIVERY_MODE_RATE] ({ commit, rootGetters }, deliveryMode) {
    try {
      commit(FETCH_START)
      const id = rootGetters.deliveryCompany.id
      const res = await api.post(`/rate-delivery-location/${id}/create`, deliveryMode)
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Tarifa actualizada exitosamente'
      })
      return res
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al actualizar la tarifa'
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
